import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';
import SEO from '../components/SEO';

const Developing = () => {
    useEffect(() => {
        const spinner = document.getElementById('spinner');
        if (spinner) {
            spinner.classList.remove('show');
            spinner.style.display = 'none';
        }
        if (window.WOW) {
            new window.WOW().init();
        }
    }, []);

    const schema = {
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "Website Development",
        "provider": {
            "@type": "LocalBusiness",
            "name": "WebBears"
        },
        "areaServed": [
            { "@type": "City", "name": "Bhiwandi" },
            { "@type": "City", "name": "Mumbai" },
            { "@type": "City", "name": "Thane" }
        ],
        "description": "Premium website development services including corporate websites, B2B portals, and web applications natively optimized for SEO and conversion."
    };

    return (
        <>
            <SEO 
                title="Top Website Development Company | WebBears"
                description="WebBears is a leading website development company offering custom React, Next.js, and WordPress solutions for businesses in Mumbai, Thane, and Bhiwandi."
                keywords="website development company, custom web development, B2B website developer, website design agency, responsive website"
                url="https://webbears.com/web-development"
                schemaMarkup={schema}
            />
            <WhatsAppFloat />
            <Navbar />

            {/* Page Header Start */}
            <div className="container-fluid page-header mb-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container mt-5 pt-5 text-center">
                    <h1 className="display-4 animated slideInDown">Website Development Company</h1>
                    <nav aria-label="breadcrumb animated slideInDown">
                        <ol className="breadcrumb justify-content-center mb-0">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item"><a href="/service">Services</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Web Development</li>
                        </ol>
                    </nav>
                </div>
            </div>
            {/* Page Header End */}

            {/* About Start */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                            <img className="img-fluid rounded shadow" src="img/images/developingp.png" alt="Website Development Company Code Interface" />
                        </div>
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
                            <p className="d-inline-block border rounded text-primary fw-semi-bold py-1 px-3">Custom Web Solutions</p>
                            <h2 className="display-5 mb-4">Engineering Powerful Digital Experiences at WebBears</h2>
                            <p className="mb-4">
                                In the modern business ecosystem, your website is the most critical asset for generating trust and securing revenue. We offer comprehensive web development services that go significantly beyond creating simple templates. We engineer digital assets that rank on Google, convert visitors effortlessly, and automate your business processes.
                            </p>
                            <p className="mb-4">
                                Whether you are a local <a href="/bhiwandi/web-development">warehouse in Bhiwandi</a> needing a corporate profile or an <a href="/ecommerce-development">eCommerce retailer</a> expanding nationally, our dedicated team of web development experts combines technical prowess with deep SEO understanding.
                            </p>
                            <a href="/contact" className="btn btn-primary py-3 px-5 mb-4">Discuss Your Project</a>
                        </div>
                    </div>
                </div>
            </div>
            {/* About End */}

            {/* Detailed SEO Content Section */}
            <div className="container-xxl py-5 bg-light">
                <div className="container">
                    <div className="text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '800px' }}>
                        <h2 className="display-6 mb-5">Our Comprehensive Website Development Process</h2>
                    </div>
                    <div className="row g-4">
                        <div className="col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="bg-white rounded p-5 h-100 shadow-sm border">
                                <h3 className="h4 mb-3">1. Discovery & UI/UX Design</h3>
                                <p>We don't believe in one-size-fits-all solutions. Our web design agency works closely with you to map out your user journeys. We utilize modern tools like Figma to curate high-end, responsive designs focusing strongly on UI/UX conversion rates. If you need dedicated structural changes, our <a href="/itc">IT Consulting</a> team provides expert guidance.</p>
                            </div>
                        </div>
                        <div className="col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="bg-white rounded p-5 h-100 shadow-sm border">
                                <h3 className="h4 mb-3">2. Mobile-First & Responsive Coding</h3>
                                <p>With over 70% of business searches happening on smartphones, mobile responsiveness isn't a feature; it's a requirement. We utilize advanced CSS and modern JavaScript frameworks (React.js, Next.js) so that your corporate website looks perfectly aligned on everything from an iPhone to a massive desktop monitor.</p>
                            </div>
                        </div>
                        <div className="col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="bg-white rounded p-5 h-100 shadow-sm border">
                                <h3 className="h4 mb-3">3. Technical SEO Integration</h3>
                                <p>What good is a website if nobody can find it? Unlike other agencies, we build technical SEO into the architecture. From dynamically injecting JSON-LD schema to optimizing image alt-tags, accelerating server response times (TTFB), and passing Google Core Web Vitals checks. We ensure your website dominates search engines in your local target areas.</p>
                            </div>
                        </div>
                        <div className="col-md-6 wow fadeInUp" data-wow-delay="0.7s">
                            <div className="bg-white rounded p-5 h-100 shadow-sm border">
                                <h3 className="h4 mb-3">4. Security & Maintenance</h3>
                                <p>Enterprise data security is paramount. From integrating SSL certificates dynamically to utilizing headless CMS structures, we prevent SQL injections and cross-site scripting. Post-launch, we provide full support scaling and managing the performance of your digital platform.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default Developing;
